import '../style.scss';
import { InputTemplate } from 'views/templates/module/inputTemplate';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { MultiSelections } from 'views/mutual/inputRadio';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { FatcaStatus } from 'views/utils/enums';
import { TemplateProps } from '../../common';

export type FatcaProps = {
  fatcaProps: any;
};

export const PersonalFatcaBase = ({
  fatcaProps,
}: FatcaProps & TemplateProps) => {
  useCustomLocationName('口座開設申込みフォーム');

  return (
    <div className="personalAccountOpenTemplate_input_check">
        <div className="personalAccountOpenTemplate_explanation">
        税法上の米国居住者とは、「グリーンカード（アメリカにおける外国人永住権）の所有者」または「一般的には、その年の米国滞在住期間が31日以上で、かつその年を含めた過去3年間の米国滞在住期間の合計が183日以上の個人」を指します。FATCAとは、米国納税義務者が、米国以外の金融機関の口座を利用し米国の税金を逃れることを防止するために制定されたものです。
        </div>
        <MultiSelections
        items={[
            {
            label: '私は米国市民（米国籍保有者）または米国居住者ではありません',
            value: FatcaStatus.No,
            },
            { label: '私は米国市民（米国籍保有者）または米国居住者です', value: FatcaStatus.Yes },
        ]}
        name="FatcaPersonal"
        {...fatcaProps}
        />
        <div className="personalAccountOpenTemplate_explanation">
        ・上記内容について正確であることを、信託の受託者である株式会社ＦＰＧ信託（以下「ＦＰＧ信託」）宛てに宣誓します。
        <br />
        ・上記記載内容に変更があった場合には、ＦＰＧ信託宛てに30日以内に連絡いたします。
        <br />
        ・「米国市民（米国籍保有者）または米国居住者」に該当する場合、ＦＰＧ信託宛てに別途所定の書式を提出いたします。同時に契約内容および米国納税者番号等についてＦＰＧ信託が米国歳入庁(IRS)に定期的に報告することに同意します。
        </div>
    </div>
  );
};
